import React from 'react'
import './areYouReady.scss'
import Title from '../../atoms/title/title'
import Button from '../../atoms/button/button'
import ovulo from '../../../assets/images/home/ovulo.png'
import { navigate } from 'gatsby-link'
import useMediaQuery from '../../../utils/useMediaQuery'

const AreYouReady = ({ isLogged }) => {
  const isMobile = useMediaQuery()
  return (
    <section className="f-section-are-you-ready">
      <div className="f-section-are-you-ready__wrapper">
        <div className="f-section-are-you-ready__content">
          {!isMobile && (
            <div className="f-section-are-you-ready__img">
              <img src={ovulo} alt="ovulo" />
            </div>
          )}
          <div className="f-section-are-you-ready__description">
            <Title color="purple" txt={['¿Estás', 'preparada?']} />
            <p className="f-section-are-you-ready__paragraph">
              Entonces, no esperes ni un minuto más
            </p>
            <Button
              color="pink"
              text={isLogged ? 'Ir a las actividades' : 'Participa'}
              action={() => {
                try {
                  window.dataLayer.push({
                    event: 'ga_event',
                    category: 'Vive el Cole :: Home',
                    action: 'Click :: ¿Estas preparada?',
                    label: isLogged ? 'Ir a las actividades' : 'Participa',
                    value: '',
                  })
                } catch (error) {
                  console.log('Datalayer error:', error)
                }
                navigate('actividades')
              }}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default AreYouReady
